import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    id: null, // optional 
    thong_tin: {
        ten: null, // required tên ng đăng ký quảng cáo
        sdt: null, // required sdt
        ten_cong_ty: null, // optional tên cty đăng ký quảng cáo
        nganh_nghe: null, // optional tên cty đăng ký quảng cáo
        san_pham_chinh: null, // optional tên cty đăng ký quảng cáo
        link: null, // optional link duong dan quang cao muon den
        noi_dung: undefined, // optional nội dung quảng cáo
        mediaId: undefined, // optional id media
        email: null, // optional Email của công ty muốn quảng cáo
    },
    trang_thai: null, // required 0: duyệt, 1: chờ duyệt, 2: Từ chối
    hien_thi: null, // required có hiển thị quảng cáo này không
    vi_tri: // optional Vị trí trang quảng cáo
    {
        trang: "TrangChu", // optional Trang hiển thị (Trang chủ, Giới thiệu, Điểm đến, Chi tiết điểm đến, Tour, Chi tiết tour, Lưu trú, Chi tiết lưu trú, Ẩm thực, Chi tiết ẩm thực, Giải trí, Chi tiết giải trí, Vé điện tử, Tin tức, Chi tiết tin tức)
        vi_tri_trang: "ViTri1", // optional Vị trí quảng cáo hiển thị
    },
    chi_phi: null, // optional, min: 0 chi phí của quảng cáo
    thoi_diem_bat_dau: null, // required Thời điểm bắt đầu
    thoi_diem_ket_thuc: null, // required thời hạn của quảng cáo
}

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg, .gif",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    },
};

model.validForm = {
    thong_tin: {
        ten: [ValidService.required],
        sdt: [ValidService.required, ValidService.checkPhone],
        ten_cong_ty: [ValidService.required],
        nganh_nghe: [ValidService.required],
        san_pham_chinh: [ValidService.required],
        link: [ValidService.checkLink],
        noi_dung: [ValidService.required],
        mediaId: [ValidService.required],
        email: [ValidService.required, ValidService.checkEmail],
    },
    trang_thai: [ValidService.required],
    hien_thi: [ValidService.required],
    vi_tri: {
        trang: [ValidService.required],
        vi_tri_trang: [ValidService.required],
    },
    chi_phi: [ValidService.required, ValidService.checkNumber],
    thoi_diem_bat_dau: [ValidService.required],
    thoi_diem_ket_thuc: [ValidService.required]

}

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "-creationTime",
    defaultSort: ["creationTime", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "thong_tin.ten": "",
            "thong_tin.ten_cong_ty": "",
            "thong_tin.nganh_nghe": "",
            "thong_tin.san_pham_chinh": "",
            // diem_den: "",
            'duyet.duoc_duyet': '',
        },
        valid: {
            "thong_tin.ten": [],
            "thong_tin.ten_cong_ty": [],
            "thong_tin.nganh_nghe": [],
            "thong_tin.san_pham_chinh": [],
            // diem_den: [],
            'duyet.duoc_duyet': [],
        },
        operator: {
            "thong_tin.ten": "$vn_text=", //:regex:, $vn_text=Viêt nam
            "thong_tin.ten_cong_ty": ":regex_i:",
            "thong_tin.nganh_nghe": ":regex_i:",
            "thong_tin.san_pham_chinh": ":regex_i:",
            // diem_den: ":regex:",
            'duyet.duoc_duyet': '',
        }
    }
};

export default model;